import { render, staticRenderFns } from "./BidderInstance.vue?vue&type=template&id=facb74a8&scoped=true&"
import script from "./BidderInstance.vue?vue&type=script&lang=js&"
export * from "./BidderInstance.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./BidderInstance.vue?vue&type=style&index=0&id=facb74a8&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "facb74a8",
  null
  ,true
)

export default component.exports